import { ArrowLeft, ArrowRight, Pause, Play } from "lucide-react";
import { useSnak } from "../snak/SnakContext";
import { PAGES } from "../data/pages";
type Props = {
  elapsed: number;
  pausedByExplore: boolean;
};

/** Minimal Snak footer: counter · progress hairline · back · NEXT. */
export function Controls({
  elapsed
}: Props) {
  const {
    page,
    total,
    playing,
    next,
    prev,
    openChapters,
    togglePlay
  } = useSnak();
  const isLast = page === total - 1;
  const duration = PAGES[page].duration;
  const within = playing && !isLast ? Math.min(1, elapsed / duration) : 1;
  const progress = (page + within) / total * 100;
  return <footer className="mx-auto w-full max-w-xl shrink-0 px-6 pb-[max(1rem,env(safe-area-inset-bottom))] pt-3" data-id="element-161" data-mp="284vf32nut4nk">
      <div className="flex items-center gap-3" data-id="element-162" data-mp="237vbcyeh8dzm">
        <button onClick={togglePlay} aria-label={playing ? "Pause guided story" : isLast ? "Start guided story from the beginning" : "Start guided story"} title={playing ? "Pause" : "Start"} className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-[var(--s-fg)] text-[var(--s-bg)] transition-opacity duration-150 hover:opacity-[0.85]" data-id="element-163" data-mp="1z4yzrrncti56">
          {playing ? <Pause className="h-3.5 w-3.5 fill-current" strokeWidth={2} data-id="element-164" data-mp="1gzceuq24l1iu" /> : <Play className="ml-px h-3.5 w-3.5 fill-current" strokeWidth={2} data-id="element-165" data-mp="1kzmxb273tkel" />}
        </button>
        <button onClick={openChapters} className="tabular shrink-0 text-[13px] font-semibold tracking-[0.14em]" aria-label="Open chapter menu" data-id="element-166" data-mp="28ph71aw4msum">
          {String(page + 1).padStart(2, "0")}
          <span className="font-normal opacity-50" data-id="element-167" data-mp="1zoj0akub078c"> / {String(total).padStart(2, "0")}</span>
        </button>

        <div className="relative h-px flex-1 bg-[var(--s-track)]" aria-hidden data-id="element-168" data-mp="24maszh2rvxdl">
          <span className="absolute -top-px left-0 h-[3px] bg-[var(--s-accent)] transition-[width] duration-300 ease-out" style={{
          width: `${progress}%`
        }} data-id="element-169" data-mp="o92sxt4k4rmf" />
        </div>

        <button onClick={prev} disabled={page === 0} aria-label="Previous chapter" className="-mx-1.5 flex h-9 w-8 shrink-0 items-center justify-center opacity-60 transition-opacity duration-150 hover:opacity-100 disabled:opacity-20" data-id="element-170" data-mp="2uxmm4uj7vsh4">
          <ArrowLeft className="h-[18px] w-[18px]" strokeWidth={1.5} data-id="element-171" data-mp="2h5omrbfb5ay5" />
        </button>
        {isLast ? <button onClick={openChapters} className="flex shrink-0 items-center gap-3 text-[13px] font-semibold tracking-[0.2em]" data-id="element-172" data-mp="2c8fziwfaygq1">
            CHAPTERS
          </button> : <button onClick={next} className="group flex shrink-0 items-center gap-2 text-[13px] font-semibold tracking-[0.18em]" data-id="element-173" data-mp="229qs5xl18eo1">
            NEXT
            <ArrowRight className="h-[18px] w-[22px] transition-transform duration-150 group-hover:translate-x-0.5" strokeWidth={1.5} data-id="element-174" data-mp="hkek20jp777" />
          </button>}
      </div>
    </footer>;
}